import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const Subtitle = styled.div.attrs(() => ({
  id: 'subtitles',
}))<{ visible: boolean }>`
  color: white;
  font-family: ${Fonts['regular']};
  font-size: ${60 * Screen.widthRatio}px;
  opacity: ${(props) => (props.visible ? 1 : 0)};
  position: fixed !important;
  text-align: center;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 1);
  top: ${830 * Screen.widthRatio}px !important;
  left: ${100 * Screen.widthRatio}px;
  width: ${1700 * Screen.widthRatio}px;
  display: block !important;
  z-index: 1;
`;

export default Subtitle;
